// extracted by mini-css-extract-plugin
export default {"logo_content":"Logo_logo_content__bFPVF","title":"Logo_title__2of0+","main_title":"Logo_main_title__jRrZ9","subtitle":"Logo_subtitle__bkm6-"};